import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Base13Icon from './../../Color graphic - no background.png';
import Base13Logo from './../../Black logo - no background.png';
import EiganSpaceLogo from './../../eiganspaceLogo.png';
import CastleIcon from '@mui/icons-material/Castle';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import List from '@material-ui/core/List';
import StreamLocatorLogo from './../../StreamLocator_logo.png';
import SMSLiveLogo from './../../smsliveLogo.png';
import CustomerJourneyGraphic from './../../customerJourneyGraphic.png';
import CustomerPieGraphic from './../../customerPieGraphic.png';
import OrganicModelGraphic from './../../organicModelGraphic.png';
import { PopupButton, InlineWidget } from "react-calendly";

import Header from './Header';
import Footer from './Footer';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  logo: {
    maxWidth: 365,
    // height: 48,
  },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  logoPadding: {
    flex: 1,
    padding: 2,
    maxWidth: 20,
    resizeMode: 'contain'
  },
  paper: {
    width: 265,
    // height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  streamLocatorLogo: {
    width: '75vw',
    maxWidth: 200,
    paddingTop: 20,
    marginRight: 100,
    // height: 312,
  },
  smsLiveLogo: {
    width: '75vw',
    maxWidth: 175,
    paddingTop: 20,
    marginRight: 100,
    // height: 312,
  },
  customerJourneyGraphic: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 650,
    // height: 400,
    resizeMode: 'contain'
  },
  customerPieGraphic: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 400,
    // height: 400,
    resizeMode: 'contain'
  },
  organicModelGraphic: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 1000,
    // height: 400,
    resizeMode: 'contain'
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  divider: {
    margin: theme.spacing(6),
  },
  answer: {
    padding: theme.spacing(2, 2, 0),
  },
  cardCaseStudy: {
    maxWidth: 972,
    transition: "0.3s",
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    "&:hover": {
      boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
    }
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
}));

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="/">
        Base13 Labs Limited
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function Services() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />

      	<Container maxWidth="lg" component="main" className={classes.heroContent} style={{color:"#37474f"}} >
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:0}}
        >
          <img className={classes.logo} src={Base13Logo}/>
        </Box>

        <Box style={{padding:10}}>
        <Typography component="h1" variant="h3" align="center" color="textPrimary" gutterBottom className={classes.answer}>
          Fully Customizable Attribution Models
        </Typography>
        <Typography component="h1" variant="h4" align="center" color="textSecondary" gutterBottom className={classes.answer}>
          Answer your toughest marketing questions.
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        <Box style={{padding:10}}></Box>

        <Grid container justifyContent="center" alignItems="center">

        <Grid item xs={12} sm={12} md={6} lg={6}>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Paper elevation={10}>
          <img className={classes.customerJourneyGraphic} src={CustomerJourneyGraphic}/>
        </Paper>
        </Box>
        </Grid>

        <Grid justifyContent="center" item xs={12} sm={12} md={6} lg={6}>
        {/*<Typography variant="h4" align="center" color="textSecondary" component="p" className={classes.answer}>Do view-throughs on Facebook increase organic?</Typography>*/}
        <Typography variant="h4" align="center" color="textSecondary" component="p" className={classes.answer}>Visualize the most common paths to conversion.</Typography>
        <Box style={{padding:20}} align="center" className={classes.button}><Button size="large" href='/ScheduleServices' variant="outlined" style={{color:"#0284c7", borderColor:"#0284c7"}} >Book a time to chat</Button></Box>
        </Grid>
        </Grid>

        <Box style={{padding:30}}></Box>

        <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} sm={12} md={6} lg={6}>
        {/*<Typography variant="h4" align="center" color="textSecondary" component="p" className={classes.answer}>What is the cost to acquire new customers vs retain existing customers?</Typography>*/}
        <Typography variant="h4" align="center" color="textSecondary" component="p" className={classes.answer}>See what types of campaigns attract which types of customers.</Typography>
        <Box style={{padding:20}} align="center" className={classes.button}><Button size="large" href='/ScheduleServices' variant="contained" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7"}} >Schedule info session</Button></Box>
        </Grid>


        <Grid justifyContent="center" item xs={12} sm={12} md={6} lg={6}>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Paper elevation={10}>
          <img className={classes.customerPieGraphic} src={CustomerPieGraphic}/>
        </Paper>
        </Box>
        </Grid>

        <Grid justifyContent="center" item xs={12} sm={12} md={12} lg={12}>
        <Box style={{padding:50}}></Box>
        {/*<Typography variant="h4" align="center" color="textSecondary" component="p" className={classes.answer}>Does spend on Facebook increase organic?</Typography>*/}
        <Typography variant="h4" align="center" color="textSecondary" component="p" className={classes.answer}>Find out if and how much Facebook spend drives organic and direct traffic.</Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box style={{padding:20}}></Box>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Paper elevation={10}>
          <img className={classes.organicModelGraphic} src={OrganicModelGraphic}/>
        </Paper>
        </Box>

        </Grid>
        <Box style={{padding:20}} align="center" className={classes.button}><Button size="large" href='/ScheduleServices' variant="outlined" style={{color:"#0284c7", borderColor:"#0284c7"}} >Book a time to chat</Button></Box>
        </Grid>

        <Box style={{padding:10}}></Box>
        <Divider variant="middle" className={classes.divider}/>
        <Typography variant="h4" align="center" color="textPrimary" component="p" className={classes.answer}>
          We Can Help
        </Typography>
        <Typography variant="h5" align="center" color="textSecondary" component="p" className={classes.answer}>
          With over a combined 20+ years in the industry, the founders of Base13 Labs have helped businesses in a number of industries solve these problems.
        </Typography>
        <Box style={{padding:10}}></Box>

        <Grid container alignItems="flex-end">

        <Grid item xs={12} sm={12} md={6} lg={6}>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Card className={classes.cardCaseStudy} >
            <Box style={{padding:20}}>
            <CardContent>
              <Typography variant="h4" color="textPrimary" component="p" align="center" style={{paddingRight:0, paddingTop:20}}>
                Product-Led
              </Typography>
              {/*<Typography variant="h6" color="textPrimary" component="p" align="center" style={{paddingRight:0, paddingTop:20}}>
                Learn how they accelerated their growth.
              </Typography>*/}
              <Typography variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:40, paddingRight:20}}>
                "We reached our data strategy goals with Base13 Labs in days saving us time and money in development costs."
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:100, paddingTop:20}}>
                James Corr, Founder
              </Typography>
              <img align="right" className={classes.smsLiveLogo} src={SMSLiveLogo}/>
            </CardContent>
            </Box>
            <Box display="flex" style={{padding:20}}>
{/*            <CardActions style={{paddingLeft:50, paddingBottom:50}}>
              <Button  fullwidth size="large" href='/SMSLiveCaseStudy' variant="outlined" style={{color:"#0284c7", borderColor:"#0284c7"}} >
                Case Study
              </Button>
            </CardActions>*/}
            </Box>

        </Card>
        </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Card className={classes.cardCaseStudy} >
            <Box style={{padding:20}}>
            <CardContent>
              <Typography variant="h4" color="textPrimary" component="p" align="center" style={{paddingRight:0, paddingTop:20}}>
                Ecommerce
              </Typography>
              {/*<Typography variant="h6" color="textPrimary" component="p" align="center" style={{paddingRight:0, paddingTop:20}}>
                Learn how they took control of their data.
              </Typography>*/}
              <Typography variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:40, paddingRight:20}}>
                "Base13 Labs made it easy for us to combine all of our sources of data so we could build
                insights to drive purchases."
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:100, paddingTop:20}}>
                Jason Salzman, COO
              </Typography>
              <img align="right" className={classes.streamLocatorLogo} src={StreamLocatorLogo}/>
            </CardContent>
            </Box>
            <Box display="flex" style={{padding:20}}>
 {/*           <CardActions style={{paddingLeft:50, paddingBottom:50}}>
              <Button  fullwidth size="large" href='/StreamLocatorCaseStudy' variant="outlined" style={{color:"#0284c7", borderColor:"#0284c7"}} >
                Case Study
              </Button>
            </CardActions>*/}
            </Box>
        </Card>
        </Box>
        </Grid>
        </Grid>

        <Grid container alignItems="flex-end" spacing={2}>

            <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end" style={{ padding: 20 }}>
            <Box style={{padding:20}}></Box>
            <Typography variant="h4" align="center" color="textPrimary" component="p" className={classes.answer}>
              Let's find a time to chat
            </Typography>
            <Box style={{padding:10}} align="center" className={classes.button}><Button size="large" href='/ScheduleServices' variant="contained" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7"}}>Schedule info session</Button></Box>

            </Grid>
           </Grid>

        </Box>
      	</Container>
        <Box mt={5}>
          <Copyright />
        </Box>
    </React.Fragment>
  );
}